export default {
  district: {},
  districts: [],
}
